<template>
  <ul class="resources-upload-list">
    <li
      class="resources-upload-list__file"
      v-for="file in list"
      :key="file.id"
    >
      <template v-if="file.status === 'finished' && (file.file_name || file.name)">
        <a
          :href="getDownloadLink(file.resource_id)"
          target="_blank"
          class="resources-upload-list__file-info ms-text"
        >
          <icon class="ms-help" type="md-document" size="16" />
          <span>{{ file.file_name || file.name }}</span>
        </a>
        <icon
          class="resources-upload-list__file-delete"
          type="md-trash"
          size="16"
          color="#f16642"
          @click="handleRemove(file)"
          v-if="hasDeletePermission"
        />
      </template>
      <template v-else>
        <i-progress
          :stroke-width="4"
          :percent="file.percentage"
          hide-info
        />
      </template>
    </li>
  </ul>
</template>

<script>
import { mainUrl } from '@/config/urls'

export default {
  props: ['list', 'type'],
  data () {
    return {
      token: this.$store.state.auth.token,
      downloadUrl: `${mainUrl}/api/download_resource`
    }
  },
  computed: {
    hasDeletePermission () {
      switch (this.type) {
        case 'bgs':
          return this.getCommonModulePerms('bank_guarantee', 'delete')
        default:
          return this.getContractModulePerms('contract_info', 'delete')
      }
    }
  },
  methods: {
    getDownloadLink (resource_id) {
      return `${this.downloadUrl}/${resource_id}?access_token=${this.token}`
    },
    handleClick (resource_id) {
      this.$emit('handle-click', resource_id)
    },
    handleRemove (file) {
      this.$emit('handle-remove', file)
    }
  }
}
</script>

<style lang="less">
.resources-upload-list {
  list-style-type: none;

  &__file {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 4px;
    border-radius: 4px;
    cursor: pointer;
    min-width: 0;

    &:hover {
      background-color: rgba(@primary-color, 0.1);

      .resources-upload-list__file-delete {
        display: block;
      }
    }

    &-info {
      flex: 1;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;

      .ms-help {
        margin-right: 8px;
      }
    }

    &-delete {
      cursor: pointer;
      margin-left: 16px;
      display: none;

      &:hover {
        opacity: 0.6;
      }
    }
  }
}
</style>
